export * from './VideoBlock';

import { VideoBlock } from './VideoBlock';

export default VideoBlock;
